import * as React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

export const StyledDatePicker = ({
  children,
  textFieldStyle = {},
  value,
  ...props
}) => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
            views={['year', 'month', 'day']}
            renderInput={(props) => <TextField {...props} />}
            value={value}
            {...props}
        />
    </LocalizationProvider>
)
